"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
tslib_1.__exportStar(require("./NoData"), exports);
//# sourceMappingURL=index.js.map